module.exports = __webpack_public_path__ + "img/home.7470ac49.svg";